import { AutoComplete, Input, Tooltip } from "antd";
import { t } from "i18next";
import { useState } from "react";
import { useNavigate } from "react-router";
import { SearchIcon, DeleteIcon, MailIcon, BackIcon } from "../../../asset";
import PrimaryButton from "../../../component/button/PrimaryButton";
import DeleteConfirmationModal from "../../../component/modal/DeleteConfirmationModal";
import SuccessModal from "../../../component/modal/SuccessModal";
import CustomTable from "../../../component/table/CustomTable";
import { ROUTES } from "../../../constant/routeConstant";
import style from './userPage.module.css'
import Breadcumbs from '../../../component/page-components/breadcumbs/breadcumbs';
import { useEffect } from "react";
import * as InvitaionServices from '../../../service/admin/User/InvitationServices';
import { useDispatch, useSelector } from "react-redux";

export default function UserInvitationList() {
    const { token } = useSelector((state) => state.auth);

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [deleteConfirmationModalOpen, setDeleteConfirmationModalOpen] = useState(false);
    const [successModalOpen, setSuccessModalOpen] = useState(false);
    const [list, setList] = useState([]);
    const [initiate, setInitiate] = useState({});
    const [totalData, setTotalData] = useState();
    const [searchKeyword, setSearchKeyword] = useState()
    const [options, setOptions] = useState([])
    const [statePageSize, setStatePageSize] = useState(10)
    const [selectedId, setSelectedId] = useState()
    const [selectedUpdatedAt, setSelectedUpdatedAt] = useState()
    const [selectedEmail, setSelectedEmail] = useState()

    const toSendInvite = () => {
        navigate(ROUTES.INVITATION.ADD)
    }

    const handleChangeLimit = (page, value) => {
        setStatePageSize(value)
        handlePagination(page, value)
    }

    const handlePagination = (page, pageSize,) => {
        setPage(page)
        setLimit(pageSize)
        getListInvitation(page, pageSize)
    }

    const getListInvitation = async (page, limit) => {
        const param = `page=${page}&limit=${limit}${searchKeyword ? `&filter=email lk ${searchKeyword}` : ''}`

        const { ok, list, initiate } = await InvitaionServices.listInvitation(token, null, param, dispatch);

        if (ok) {
            setInitiate(initiate);
            setTotalData(initiate.count_data)
            setList(list);
        }
    }

    const doInitializeInvitation = async (page, limit) => {
        const param = `page=${page}&limit=${limit}${searchKeyword ? `&filter=email lk ${searchKeyword}` : ''}`

        try {
            const response = await InvitaionServices.initiateInvitation(token, null, param, dispatch);
            if (response && response.ok) {
                setTotalData(response.data.count_data)
            }
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        getListInvitation(page, limit);
    }, [page, limit])

    const doDeleteInvitation = async () => {
        try {
            const response = await InvitaionServices.deleteInvitation(token, null, selectedId, selectedUpdatedAt, dispatch)
            if (response && response.ok) {
                setDeleteConfirmationModalOpen(false)
                setSuccessModalOpen(true)
                setSelectedId()
                setSelectedUpdatedAt()
                getListInvitation(1, 10)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const deleteConfirmation = (id, updated_at, email) => {
        setDeleteConfirmationModalOpen(true)
        setSelectedId(id)
        setSelectedUpdatedAt(updated_at)
        setSelectedEmail(email)
    }

    const backToUserList = () => {
        navigate(ROUTES.USER.LIST)
    }

    const UserInvitationListColumn = [
        {
            title: (
                <span className="font-roboto text-lg text-[#222222]">
                    {t("USER_INVITATION:EMAIL_FIELD")}
                </span>
            ),
            dataIndex: 'email',
            key: 'email',
            render: (email) => <span>{email}</span>,
        },
        {
            title: (
                <span className="font-roboto text-lg text-[#222222]">
                    {t("USER_INVITATION:DATA_GROUP_FIELD")}
                </span>
            ),
            dataIndex: 'dataGroup',
            key: 'dataGroup',
            render: (dataGroup) => <span>{dataGroup}</span>,
        },
        {
            title: (
                <span className="font-roboto text-lg text-[#222222]">
                    {t("USER_INVITATION:ROLE_FIELD")}
                </span>
            ),
            dataIndex: 'role',
            key: 'role',
            render: (role) => <span>{role}</span>,
        },
        {
            title: (
                <span className="font-roboto text-lg text-[#222222]">
                    {t("USER_INVITATION:STATUS_FIELD")}
                </span>
            ),
            dataIndex: 'status',
            key: 'status',
            render: (status) => <span>{status}</span>,
        },
        {
            title: (
                <span className="font-roboto text-lg text-[#222222]">
                    {t("USER_INVITATION:ACTION_FIELD")}
                </span>
            ),
            dataIndex: 'action',
            key: 'action',
            render: (action) => <span>{action}</span>,
        },
    ]

    const dataSource = list?.map((item) => {
        return (
            {
                email: (
                    <span className="font-roboto text-lg text-[#222222]">
                        {item.email}
                    </span>
                ),
                dataGroup: (
                    <span className="font-roboto text-lg text-[#222222]">
                        {item.data_group_name}
                    </span>
                ),
                role: (
                    <span className="font-roboto text-lg text-[#222222]">
                        {item.role_name}
                    </span>
                ),
                status: (
                    <div className="px-[6px] py-[2px] bg-[#46A3FC1A] rounded-[9px] w-fit">
                        {
                            item.status === 'S' ? (
                                <span className="font-roboto text-[#46A3FC]">{t("USER_INVITATION:INVITATION_SENT")}</span>
                            ) : item.status === 'O' ? (
                                <span className="font-roboto text-[#F8AC30]">{t("USER_INVITATION:INVITATION_OPENED")}</span>
                            ) : item.status === 'E' ? (
                                <span className="font-roboto text-[#FF0000]">{t("USER_INVITATION:INVITATION_EXPIRED")}</span>
                            ) : (
                                <span className="font-roboto text-[#57C22D]">{t("USER_INVITATION:USER_REGISTERED")}</span>
                            )
                        }

                    </div>
                ),
                action: (
                    <div className="flex gap-[26px]">
                        <Tooltip title={t("USER_INVITATION:DELETE_TOOLTIP")} color="#CF0000">
                            <button
                                onClick={() => deleteConfirmation(item.id, item.updated_at, item.email)}
                                disabled={item.status !== 'S' ? true : false}
                            >
                                <img src={DeleteIcon} alt="icon-deleted" />
                            </button>
                        </Tooltip>
                    </div>
                )
            }
        )
    });

    const onSearch = (event) => {
        let keyword = event.target.value
        setSearchKeyword(keyword)
        doSearch(keyword)
    }

    const doSearch = async (keyword) => {
        if (keyword !== '') {
            try {
                const response = await InvitaionServices.getSearchRecommendation(token, null, keyword, dispatch);
                if (response && response.ok) {
                    let resOption = response.data
                    let options = []

                    for (let i = 0; i < resOption.length; i++) {
                        if (options.length === 0) {
                            options.push(resOption[i])
                        }
                        
                    }

                    console.log(options)

                    setOptions(options)
                }
            } catch (error) {
                console.log(error)
            }
        }
    }

    const onSelect = async (keyword) => {
        setSearchKeyword('')
        doInitializeInvitation(page, limit)
        try {
            const response = await InvitaionServices.getSearchResult(token, null, keyword, dispatch);
            if (response && response.ok) {
                setList(response.data)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const doClear = () => {
        setSearchKeyword('')
        setOptions([])
        getListInvitation(1, 10)
    }

    return (
        <div className='p-[24px] flex flex-col gap-[24px]'>

            <DeleteConfirmationModal
                isOpen={deleteConfirmationModalOpen}
                onOk={() => setDeleteConfirmationModalOpen(false)}
                onCancel={() => doDeleteInvitation()}
                closable={false}
                width={440}
                className={style.modalContainer}
                okText="Cancel"
                cancelText="Yes, Delete"
                title="Delete Data?"
                description={<p>Are you Sure want to delete<br /><strong>{selectedId}-{selectedEmail}</strong>?</p>}
            />

            <SuccessModal
                isOpen={successModalOpen}
                onOk={() => setSuccessModalOpen(false)}
                closable={false}
                width={280}
                className={style.deleteModal}
                okText="Ok"
                title="Success"
                description="Your data has been deleted"
            />

            <Breadcumbs
                jmlLevel={4}
                menuLevel1={`Admin`}
                menuLevel2={`User Management`}
                menuLevel3={`User`}
                menuLevel4={`Invitation`}
            />

            <div className="flex items-center gap-[22px] cursor-pointer w-fit" onClick={() => backToUserList()}>
                <img src={BackIcon} alt="" />
                <h1 className='font-sans-bold text-2xl' id='title'>{t("USER_INVITATION:TITLE")}</h1>
            </div>


            <div className={style.headerContainer + ' flex justify-between items-center'}>
                <AutoComplete
                    options={options}
                    onSelect={onSelect}
                    allowClear={true}
                    onClear={() => doClear()}
                >
                    <Input
                        placeholder={t("USER_INVITATION:SEARCH_PLACEHOLDER")}
                        height={47}
                        onChange={(event) => onSearch(event)}
                        suffix={<img src={searchKeyword ? null : SearchIcon} />}
                        style={{ fontSize: "20px" }}
                    />
                </AutoComplete>

                <PrimaryButton
                    text={t("USER_INVITATION:SEND_INVITATION")}
                    suffixIcon={<img src={MailIcon} alt='icon-mail' />}
                    action={toSendInvite}
                />
            </div>

            <div className={style.tableContainer}>
                <CustomTable columns={UserInvitationListColumn} data={dataSource} pageLimit={statePageSize} onChange={(page, pageSize) => handleChangeLimit(page, pageSize)} total={totalData} showPagination />
            </div>
        </div>
    );
}
